import { useEffect, useRef } from 'react';

export const useWindowUnload = (handler: () => void) => {
	const handlerRef = useRef(handler);

	useEffect(() => {
		handlerRef.current = handler;
	}, [handler]);

	useEffect(() => {
		const listener = () => handlerRef.current();

		window.addEventListener('beforeunload', listener);
		window.addEventListener('pagehide', listener);

		return () => {
			window.removeEventListener('beforeunload', listener);
			window.removeEventListener('pagehide', listener);
		};
	}, []);
};
